// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__fPMUv","prev":"style_prev__KXTgW","next":"style_next__j8wp7","container":"style_container__wseEX"};